import makeAuditAiApi from '@counsel-project/counsel-audit-ai-api'
import { url } from './url'

export const auditAiRequest = makeAuditAiApi({
  url: url + '/audit-ai',
  key: '',
  withCredentials: true,
})
